import React, { useContext } from "react";
import { LegacyCard as Card, Text } from "@shopify/polaris";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";

import { customerProp } from "app/orders/modules/admin/features/view/propsType";

const Customer = (props) => {
  const { cms } = useContext(PrivateContext);
  const { data } = props;
  const { customer, shippingAddress, billingAddress } = data || {};
  const { default_address: defaultAddress, email, phone } = customer || {};
  const { address1, address2, zip, city, province, country, phone: shippingPhone } = shippingAddress || {};
  const {
    address1: billingAddress1,
    address2: billingAddress2,
    zip: billingZip,
    city: billingCity,
    province: billingProvince,
    country: billingCountry,
    phone: billingPhone,
  } = billingAddress || {};
  return (
    <Card title={cms("label.customer")}>
      <Card.Section>
        <Text as="span" tone={!(customer && defaultAddress && defaultAddress.name) && constant.SUBDUED}>
          {(customer && defaultAddress && defaultAddress.name) || cms("label.noCustomer")}
        </Text>
      </Card.Section>
      <Card.Section title={cms("label.contactInformation")}>
        <Text as="span" tone={!(customer && email) && constant.SUBDUED}>
          <p>{(customer && email) || cms("label.noEmailAddress")}</p>
          <p>{(customer && phone) || cms("label.noPhoneNumber")}</p>
        </Text>
      </Card.Section>
      <Card.Section title={cms("label.shippingAddress").toUpperCase()}>
        {shippingAddress ? (
          <Text as="span" variant="bodySm">
            <p>
              {shippingAddress && address1}
              {shippingAddress && address2}
            </p>
            <p>
              {shippingAddress && zip}
              {shippingAddress && city}
              {shippingAddress && province}
            </p>
            <p>{shippingAddress && country}</p>
            <p>{shippingAddress && shippingPhone}</p>
          </Text>
        ) : (
          <Text as="span" tone={constant.SUBDUED}>
            {cms("label.noShippingAddress")}
          </Text>
        )}
      </Card.Section>
      <Card.Section title={cms("label.billingAddress")}>
        <Text as="span" variant="bodySm">
          {billingAddress ? (
            <Text as="span" variant="bodySm">
              <p>
                {billingAddress && billingAddress1}
                {billingAddress && billingAddress2}
              </p>
              <p>
                {billingAddress && billingZip}
                {billingAddress && billingCity}
                {billingAddress && billingProvince}
              </p>
              <p>{billingAddress && billingCountry}</p>
              <p>{billingAddress && billingPhone}</p>
            </Text>
          ) : (
            <Text as="span" tone={constant.SUBDUED}>
              {cms("label.noBillingAddress")}
            </Text>
          )}
        </Text>
      </Card.Section>
    </Card>
  );
};
Customer.propTypes = customerProp.type;
export default Customer;
